module.exports = __webpack_public_path__ + "img/202506_01_sp.004a9330.jpg";